export const convertToNumber = (str: string) => {
  if (!str) return 0

  const finalStr = str.replace(",", ".")

  if (isNaN(Number(finalStr))) return 0

  return Number(finalStr)
}

export const formatPrice = (number: number | string): string => {
  if (!number) return "0"

  const maximumFractionDigits = `${number}`.includes(".") ? 2 : 0

  return (
    new Intl.NumberFormat("pl-PL", {
      style: "decimal",
      maximumFractionDigits: maximumFractionDigits,
      minimumFractionDigits: maximumFractionDigits,
    })
      // @ts-expect-error Intl is not typed
      .format(number.toFixed(2))
  )
}
